<section class="" *ngIf="color === 'pur'">
    <div class=" text-white fakeHeight">
    <div *ngIf="usedLanguage === 'en'" class="col py-3 px-lg-5  h-100 d-flex justify-content-center align-items-center ">
        <button type="button" class="btn btn-primary btn-lg ">
            <a href="https://old.cbic.gov.in/htdocs-cbec/home_links/dept_officers" target="_blank">Click here to navigate to Departmental Officers page
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send"
                    viewBox="0 0 16 16">
                    <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                </svg>
            </a>
        </button>



    </div>

    <div  *ngIf="usedLanguage === 'hi' " class="col py-3 px-lg-5  h-100 d-flex justify-content-center align-items-center ">
        <button type="button" class="btn btn-primary btn-lg ">
            <a href="https://old.cbic.gov.in/htdocs-cbec/home_links/dept_officers" target="_blank">विभागीय अधिकारी के लिए यहां क्लिक करें
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send"
                    viewBox="0 0 16 16">
                    <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                </svg>
            </a>
        </button>



    </div>
</div>
</section>

<section class="black-theme" *ngIf="color === 'bule'">
    <div class=" text-white fakeHeight">
    <div *ngIf="usedLanguage === 'en'" class="col py-3 px-lg-5  h-100 d-flex justify-content-center align-items-center ">
        <button type="button" class="btn btn-primary btn-lg ">
            <a href="https://old.cbic.gov.in/htdocs-cbec/home_links/dept_officers" target="_blank">Click here to navigate to Departmental Officers page
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send"
                    viewBox="0 0 16 16">
                    <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                </svg>
            </a>
        </button>



    </div>

    <div  *ngIf="usedLanguage === 'hi' " class="col py-3 px-lg-5  h-100 d-flex justify-content-center align-items-center ">
        <button type="button" class="btn btn-primary btn-lg ">
            <a href="https://old.cbic.gov.in/htdocs-cbec/home_links/dept_officers" target="_blank">विभागीय अधिकारी के लिए यहां क्लिक करें
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send"
                    viewBox="0 0 16 16">
                    <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                </svg>
            </a>
        </button>



    </div>
</div>
</section>